/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FrenchInputs */



/**
* | output |
* | --- |
* | "Français" |
*
* @param {FrenchInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const french = /** @type {((inputs?: FrenchInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FrenchInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Français")
	if (locale === "de") return /** @type {LocalizedString} */ ("Französisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("Francese")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Французский")
	if (locale === "es") return /** @type {LocalizedString} */ ("Francés")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("法语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フランス語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़्रेंच")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Francês")
	return /** @type {LocalizedString} */ ("Français")
});